module.exports = __webpack_public_path__ + "media/payment/visa-icon-abed903d.svg";